import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as s, useEffect as o } from "react";
import { disposables as t } from '../utils/disposables.js';

function p() {
  var _s = s(t),
      _s2 = _slicedToArray(_s, 1),
      e = _s2[0];

  return o(function () {
    return function () {
      return e.dispose();
    };
  }, [e]), e;
}

export { p as useDisposables };